import { render } from "./QcFormBuilderTemplate.vue?vue&type=template&id=42a98abc&scoped=true"
import script from "./QcFormBuilderTemplate.vue?vue&type=script&lang=js"
export * from "./QcFormBuilderTemplate.vue?vue&type=script&lang=js"

import "./QcFormBuilderTemplate.vue?vue&type=style&index=0&id=42a98abc&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42a98abc"]])

export default __exports__